import './BlogsPage.css';
const blogs = [
  {
    id: 1,
    tag: "GIS & Utilities",
    date: "April 28, 2026",
    title: "Why Utility Network Migration Needs an Industrial Approach",
    excerpt: "Most GIS migrations fail not because of technology — but because they underestimate the scale of data complexity. Here's how an industrialised migration framework changes the outcome.",
    readTime: "6 min read",
    icon: "🗺️",
    color: "#00d4ff",
  },
  {
    id: 2,
    tag: "Grid Modernisation",
    date: "April 14, 2026",
    title: "The Hidden Cost of Poor Grid Data Quality",
    excerpt: "Inaccurate network records don't just cause frustration — they drive real costs in safety incidents, regulatory penalties, and delayed investment decisions. We quantify the impact.",
    readTime: "5 min read",
    icon: "⚡",
    color: "#f7971e",
  },
  {
    id: 3,
    tag: "Telecom",
    date: "March 31, 2026",
    title: "Conduit Management: The Overlooked Foundation of Fibre Rollouts",
    excerpt: "As operators race to deploy FTTP at scale, the quality of underground conduit data is becoming a critical bottleneck. Here's what leading operators are doing differently.",
    readTime: "7 min read",
    icon: "🔌",
    color: "#00b8a0",
  },
  {
    id: 4,
    tag: "Digital Transformation",
    date: "March 18, 2026",
    title: "From GIS to Digital Twin: The Utility Network Evolution",
    excerpt: "The transition from a traditional GIS system to a live, operational digital twin requires more than technology — it demands a new operating model. A practitioner's guide.",
    readTime: "9 min read",
    icon: "🌐",
    color: "#4facfe",
  },
  {
    id: 5,
    tag: "AI & Analytics",
    date: "March 5, 2026",
    title: "How AI is Reshaping Predictive Maintenance for Electricity Networks",
    excerpt: "Machine learning models trained on historical fault data are helping utilities shift from time-based to condition-based maintenance — reducing costs and improving reliability.",
    readTime: "8 min read",
    icon: "🤖",
    color: "#f093fb",
  },
  {
    id: 6,
    tag: "Case Study",
    date: "February 20, 2026",
    title: "50 Million Assets. Zero Migration Failures. The rUNr® Story.",
    excerpt: "How Inovaantage's proprietary migration platform has become the benchmark for large-scale Utility Network migrations across three continents.",
    readTime: "10 min read",
    icon: "🚀",
    color: "#43e97b",
  },
];

export default function BlogsPage() {
  return (
    <div className="subpage-root">
      <section className="subpage-hero" style={{ "--accent": "#00d4ff" }}>
        <div className="subpage-hero-badge">
          <span className="subpage-icon">📝</span>
          <span>Knowledge Hub</span>
        </div>
        <h1 className="subpage-title">Blogs & Insights</h1>
        <p className="subpage-tagline">Expert perspectives on utilities, telecoms, geospatial technology, and digital transformation.</p>
      </section>

      <section className="subpage-section">
        <div className="subpage-container">
          <div className="blogs-grid">
            {blogs.map((blog) => (
              <article key={blog.id} className="blog-card" style={{ "--accent": blog.color }}>
                <div className="blog-card-header">
                  <span className="blog-icon">{blog.icon}</span>
                  <span className="blog-tag" style={{ color: blog.color }}>{blog.tag}</span>
                </div>
                <h2 className="blog-title">{blog.title}</h2>
                <p className="blog-excerpt">{blog.excerpt}</p>
                <div className="blog-footer">
                  <span className="blog-date">{blog.date}</span>
                  <span className="blog-read">{blog.readTime}</span>
                </div>
                <button className="blog-read-btn" style={{ color: blog.color }}>
                  Read Article →
                </button>
              </article>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
}
